import { render, staticRenderFns } from "./transportes.vue?vue&type=template&id=61565ce4&scoped=true&"
import script from "./transportes.vue?vue&type=script&lang=js&"
export * from "./transportes.vue?vue&type=script&lang=js&"
import style0 from "./transportes.vue?vue&type=style&index=0&id=61565ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61565ce4",
  null
  
)

export default component.exports